import { render, staticRenderFns } from "./TabClassSession.vue?vue&type=template&id=eff537c6"
import script from "../../../services/student/tab-classsession.js?vue&type=script&lang=js&external"
export * from "../../../services/student/tab-classsession.js?vue&type=script&lang=js&external"
import style0 from "../../../assets/css/student/tab-classsession.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports